import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createCollection } from 'actions/collections';
import { setPopUp } from 'actions/environment';
import cn from 'classnames';
import styles from './Collections.scss';
import CollectionsDialog from '../CollectionsDialog';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

class Collections extends Component {

  handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const { profile, objectType, building } = this.props;
    trackGA(gaEvent[eventName]({
      eventLabel,
      eventContent: eventContent || building.data.title,
      productType: objectType,
      productName: building.data.title,
      productID: building.data.id,
      user_id: profile.id
    }));
  }

  handleClick = () => {
    const { onClick, profile, objectType } = this.props;

    if (onClick) {
      onClick();
    }

    this.props.setPopUp(
      <CollectionsDialog
        building={this.props.building}
        profile={profile}
        objectType={objectType}
      />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
        onClose: () => this.handleTrackEvent({
          eventName: 'buildingCollectionDialogButtonsClick',
          eventLabel: 'zakryt'
        })
      }
    );
  }

  render() {
    const { className, t } = this.props;
    return (
      <div className={cn(styles.Collections, className)}>
        <button
          className={styles.ButtonAddToCollection}
          onClick={this.handleClick}
          data-tip={t('components.building.main.collections.add')}
          data-for="global"
        >
          <span><i></i><i></i></span>
        </button>
      </div>
    );
  }
}

export default withTranslation()(connect(
  state => state.profile,
  {
    createCollection,
    setPopUp
  }
)(Collections));



// WEBPACK FOOTER //
// ./src/components/Building/Main/Collections/Collections.js